import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';

// Providers
import { PwaService } from '../../../core/providers/services/pwa/pwa.service';
import { MatButtonModule } from '@angular/material/button';



@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    MatButtonModule
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent {
  public readonly pwaService: PwaService = inject(PwaService);
}
